import React, { useEffect, useState } from 'react';
import { Loader } from 'rsuite';
import { Card } from 'Components/Common/Card/Card';
import { NumericFormat } from 'react-number-format';
import api from 'Components/_helpers/api';
import axios from 'axios';

export const Resumen = (props) => {
  const { resumen, codigoGeneracion } = props;
  const [catDefsRes, setCatDefsRes] = useState({ loading: true });

  const getCATDef_Res = (resp) => {
    const reqs = []

    if(resp.condicionOperacion)
      reqs.push(api.post(`${api.getUri()}CAT/CAT016`, { code: resp.condicionOperacion.toString() }))

    axios.all(reqs).then(
      axios.spread((condicionOperacion) => {
        const state = {
          loading: false
        }

        if(condicionOperacion)
          state.condicionOperacion = condicionOperacion.data.items.pop()
        
          setCatDefsRes(state);
      })
    );
  };

  useEffect(() => {
    getCATDef_Res(resumen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigoGeneracion]);

  return (
    <Card header={'Descripción resumida de las operaciones'}>
      <dl>
        <dt>Total de Operaciones Afectas</dt>
        <dd>
          <NumericFormat value={resumen.totalGravada} displayType={'text'} thousandSeparator={true} prefix={'$'} />
        </dd>
        {(resumen.descuento && resumen.descuento !== 0) && (
          <>
            <dt>Monto global de Descuento</dt>
            <dd>
              <NumericFormat value={resumen.descuento} displayType={'text'} thousandSeparator={true} prefix={'$'} />
            </dd>
            <dt>Porcentaje de descuento</dt>
            <dd>
              <NumericFormat value={resumen.porcentajeDescuento} displayType={'text'} thousandSeparator={true} suffix={'%'} />
            </dd>
            <dt>Total del monto de descuento</dt>
            <dd>
              <NumericFormat value={resumen.totalDescu} displayType={'text'} thousandSeparator={true} prefix={'$'} />
            </dd>
          </>
        )}
        {(resumen.seguro && resumen.seguro !== 0) && (
          <>
            <dt>Seguro</dt>
            <dd>
              <NumericFormat value={resumen.seguro} displayType={'text'} thousandSeparator={true} prefix={'$'} />
            </dd>
          </>
        )}
        {(resumen.flete && resumen.flete !== 0) && (
          <>
            <dt>Flete</dt>
            <dd>
              <NumericFormat value={resumen.flete} displayType={'text'} thousandSeparator={true} prefix={'$'} />
            </dd>
          </>
        )}
        <dt>Total otros créditos o pagos a favor del receptor</dt>
        <dd>
          <NumericFormat value={resumen.totalNoGravado} displayType={'text'} thousandSeparator={true} prefix={'$'} />
        </dd>
        <dt>Total general</dt>
        <dd>
          <NumericFormat value={resumen.totalPagar} displayType={'text'} thousandSeparator={true} prefix={'$'} />
        </dd>
        <dt>Valor en Letras</dt>
        <dd>{resumen.totalLetras}</dd>
        {resumen.condicionOperacion && (
          <>
            <dt>Condiciones de la Operación</dt>
            <dd>{catDefsRes.loading ? <Loader /> : `${catDefsRes.condicionOperacion.code} - ${catDefsRes.condicionOperacion.value}`}</dd>
          </>
        )}        
        <dt>Total de Operaciones Afectas</dt>
        <dd>
          <NumericFormat value={resumen.totalGravada} displayType={'text'} thousandSeparator={true} prefix={'$'} />
        </dd>
      </dl>
    </Card>
  );
};
